import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=f2566602&scoped=true&"
import script from "./youtube-video.vue?vue&type=script&lang=js&"
export * from "./youtube-video.vue?vue&type=script&lang=js&"
import style0 from "./youtube-video.vue?vue&type=style&index=0&id=f2566602&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2566602",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
